import React from "react";
import Building from './icons/building';
import Dollar from './icons/dollar';
import User from './icons/user';
import Graph from './icons/graph';
import Wrench from './icons/wrench';
import Blocks from './icons/blocks';

const whyCards = [
    {
        title: "Remote / Hybrid Complexity",
        description: "58% of companies say hybrid work hurts visibility and communication (PMI 2025 Pulse).",
        icon: <Building />
    },
    {
        title: "Economic Pressure",
        description: "63% of CFOs demand teams do more with less (Gartner 2025).",
        icon: <Graph />
    },
    {
        title: "High Cost of Failure",
        description: "$1 in every $9 invested in projects is wasted due to poor performance (PMI 2024).",
        icon: <Dollar />
    },
    {
        title: "Tool Overload",
        description: "54% of firms cite tool sprawl as a barrier to delivery (Gartner 2024).",
        icon: <Wrench />
    },
    {
        title: "PM Talent Shortage",
        description: "Experienced PMO leaders are harder to hire than ever.",
        icon: <User />
    },
    {
        title: "Maturity Gap Widens",
        description: "67% of organizations rate PMO maturity at level 2 or below (on 5-point scale). This means most are missing the structure and systems needed to drive consistent, scalable execution.",
        icon: <Blocks />
    },
]

const Why = () => {
    return (
        <div className="w-full px-4 md:px-8 lg:px-16 mt-8 lg:mt-20 lg:container mx-auto">
            <div className="w-full flex flex-col lg:px-16 md:px-12 p-6 md:py-12 lg:py-20 gap-16 bg-white rounded-2xl items-start justify-start">
                <div className="text-left flex flex-col gap-6">
                    <h2 className="lg:text-5xl text-3xl font-normal pointer-events-none text-blue10">Why ReadyPMO?</h2>
                    <p className="lg:text-xl text-base leading-normal pointer-events-none text-blue10">The business environment in 2026 is tougher than ever:</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 justify-between items-stretch">
                    {whyCards.map((card, index) => (
                        <div key={index} className="bg-grey30 border border-lightBlue80 border-solid rounded-2xl p-4 md:p-8 text-left gap-2 flex flex-col justify-start items-start">
                            <div className="w-12 h-12 aspect-square flex justify-center items-center bg-blue80 rounded-full">
                                {card.icon}
                            </div>
                            <h3 className="text-2xl lg:text-3xl font-normal pointer-events-none text-blue10">{card.title}</h3>
                            <p className="text-base md:text-lg leading-normal pointer-events-none text-blue70">{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Why;